export const MAIN_MENU_WIDTH = 80;
export const MAIN_SUB_MENU = MAIN_MENU_WIDTH + 320;
